export enum SidebarType {
    //#region Shared Components 1-100

    //#region Employee Components 101-200
    CompanyEmployeeAdd = 101,
    CompanyEmployeeEdit = 102,
    UserAdd = 103,
    UserEdit = 104,
    
    //#region Course Components 201-300
    CompanyCourseAdd = 201,
    CompanyCourseEdit = 202,

    //#region Company Components 301-400
    CompanyAdd = 301,
    CompanyEdit = 302,

    //#region Menu Components 401-500
    CategoryGroupAdd = 401,
    CategoryGroupEdit = 402,
    CategoryAdd = 403,
    CategoryEdit = 404,
    MenuItemAdd = 405,
    MenuItemEdit = 406,
    ModifierGroupAdd = 407,
    ModifierGroupEdit = 408,
    ModifierAdd = 409,
    ModiferEdit = 410,
    MenuSkuItemAdd = 411,
    MenuSkuItemEdit = 412,
    MenuItemSkuImport = 413,
    TagGroupAdd = 414,
    TagGroupEdit = 415,
    TagAdd = 416,
    TagEdit = 417,


    //#region Discounts - Specials Components 501-600
    SpecialAdd = 501,
    SpecialEdit = 502,
    DiscountAdd = 503,
    DiscountEdit = 504,
}